import { useEffect, useState } from "react";
import { Bell, CheckCheck, Info, CheckCircle2, AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { PortalHeader, EmptyState, fmtDate } from "@/pages/client/_shared";

const ICONS = { info: Info, success: CheckCircle2, warning: AlertTriangle };
const COLORS = { info: "text-[#D4AF37]", success: "text-emerald-400", warning: "text-amber-400" };

export default function ClientNotifications() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/portal/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const readAll = async () => { await api.post("/portal/notifications/read-all").catch(() => {}); load(); };

  return (
    <div className="fv-fade-up">
      <PortalHeader title="Notifications" subtitle="Stay up to date with everything happening in your portal."
        action={items.some((i) => !i.read) && (
          <button onClick={readAll} data-testid="client-notif-readall"
            className="text-sm text-[#D4AF37] hover:underline flex items-center gap-1.5 shrink-0"><CheckCheck className="w-4 h-4" /> Mark all read</button>
        )} />

      {items.length === 0 ? (
        <EmptyState icon={Bell} text="No notifications yet." testid="client-notif-empty" />
      ) : (
        <div className="space-y-2.5" data-testid="client-notif-list">
          {items.map((n) => {
            const Icon = ICONS[n.kind] || Info;
            return (
              <div key={n.notif_id} data-testid={`client-notif-${n.notif_id}`}
                className={`flex items-start gap-3 rounded-xl border p-4 ${n.read ? "border-white/8 bg-[#121214]" : "border-[#D4AF37]/25 bg-[#151310]"}`}>
                <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${COLORS[n.kind] || COLORS.info}`} />
                <div className="min-w-0"><div className="text-white text-sm font-medium">{n.title}</div>
                  <p className="text-sm text-[#A1A1AA]">{n.message}</p>
                  <div className="text-xs text-[#52525B] mt-1">{fmtDate(n.created_at)}</div></div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
